const protocol = window.location.protocol; // http: or https:

// BASE_URL = `${protocol}//shreevaibhavlaxmimahilaurban.in/backend`;
const BASE_URL = `${protocol}//shreevaibhavlaxmimahilaurban.in/backend`;
// const BASE_URL = `http://localhost/shreevaibhavlaxmiurban.in/backend`;

export default BASE_URL;
